const staffMembers = [

  {
    id: 'owner2',
    username: 'Lurrn',
    role: 'Network Owner',
    subroles: [],
    skinUrl: '/assets/images/minecraft-skins/lurrn.png',
    discord: 'Lurrn'
  },
  {
    id: 'owner3',
    username: 'Encz',
    role: 'Network Owner',
    subroles: [],
    skinUrl: '/assets/images/minecraft-skins/musab.png',
    discord: 'Encz'
  },
  

  {
    id: 'manager1',
    username: 'Rio',
    role: 'Manager',
    subroles: ['Staff Manager', 'Partner Relations Manager', 'Tier Testing Manager', 'Subhumans Manager', 'Advertisements Manager', 'Screenshare Manager', 'Verified Testing Servers Manager'],
    skinUrl: '/assets/images/minecraft-skins/rio.png',
    discord: 'ObsessiveBf'
  },
  

  {
    id: 'admin1',
    username: 'Weqy',
    role: 'Tierlist Administrator',
    subroles: ['Low Tier Testing Manager', 'Events Assistant', 'Subhumans Overseer', 'TLC Overseer'],
    skinUrl: '/assets/images/minecraft-skins/weqy.png',
    discord: 'Weqy'
  },
  {
    id: 'admin2',
    username: 'ItzLianton',
    role: 'Tierlist Administrator',
    subroles: ['Tickets Overseer', 'TLC Manager'],
    skinUrl: '/assets/images/minecraft-skins/linaton.png',
    discord: 'ItzLinatonMC'
  },
  

  {
    id: 'regulator1',
    username: 'IdkQZ',
    role: 'Regulator',
    subroles: ['High Tier Testing Manager'],
    skinUrl: '/assets/images/minecraft-skins/qz.png',
    discord: 'QZ69_'
  },
  {
    id: 'regulator2',
    username: 'Visquint',
    role: 'Regulator',
    subroles: ['Tester Applications Assistant', 'Moderation Overseer', 'Tester & Community Reports Assistant'],
    skinUrl: '/assets/images/minecraft-skins/vis.png',
    discord: 'Loveatomb'
  },
  {
    id: 'regulator3',
    username: 'Acilic',
    role: 'Regulator',
    subroles: ['Tickets Overseer', 'TLC Overseer', 'Tester & Community Reports Assistant'],
    skinUrl: '/assets/images/minecraft-skins/acilic.png',
    discord: 'Acilic'
  },
  {
    id: 'regulator4',
    username: 'Skied',
    role: 'Regulator',
    subroles: ['Events Assistant', 'Tester Applications Assistant', 'Tester & Community Reports Assistant', 'Subhuman Appeals Assistant' ],
    skinUrl: '/assets/images/minecraft-skins/skied.png',
    discord: 'Acilic'
  },
  

  {
    id: 'mod1',
    username: 'LegitIdiort',
    role: 'Moderator',
    subroles: [],
    skinUrl: '/assets/images/minecraft-skins/id.png',
    discord: 'idiort'
  },
  {
    id: 'mod2',
    username: 'KIKIGOLUBOVIC',
    role: 'Moderator',
    subroles: [],
    skinUrl: '/assets/images/minecraft-skins/gold.png',
    discord: 'goldtouch'
  },
  {
    id: 'mod3',
    username: 'Bu_d',
    role: 'Moderator',
    subroles: [],
    skinUrl: '/assets/images/minecraft-skins/bud.png',
    discord: 'bu.d'
  },
  {
    id: 'mod4',
    username: 'N00b_exe',
    role: 'Moderator',
    subroles: [],
    skinUrl: '/assets/images/minecraft-skins/noob.png',
    discord: 'N00b_exe'
  },
  {
    id: 'mod5',
    username: 'Kaiif',
    role: 'Moderator',
    subroles: [],
    skinUrl: '/assets/images/minecraft-skins/kaiif.png',
    discord: 'Kaiif'
  },
  {
    id: 'mod6',
    username: 'phhoves',
    role: 'Moderator',
    subroles: [],
    skinUrl: '/assets/images/minecraft-skins/phhoves.png',
    discord: 'poveshumor'
  },
  {
    id: 'mod7',
    username: 'Prusso',
    role: 'Moderator',
    subroles: ['Events Assistant'],
    skinUrl: '/assets/images/minecraft-skins/prusso.png',
    discord: 'Prusso '
  },
  {
    id: 'mod8',
    username: 'warpzzz',
    role: 'Moderator',
    subroles: [],
    skinUrl: '/assets/images/minecraft-skins/warp.png',
    discord: 'warpzzz '
  },
  


];


export const staffByRole = {
  'Network Owner': staffMembers.filter(member => member.role === 'Network Owner'),
  'Manager': staffMembers.filter(member => member.role === 'Manager'),
  'Tierlist Administrator': staffMembers.filter(member => member.role === 'Tierlist Administrator'),
  'Regulator': staffMembers.filter(member => member.role === 'Regulator'),
  'Moderator': staffMembers.filter(member => member.role === 'Moderator'),
  'Senior Tester': staffMembers.filter(member => member.role === 'Senior Tester')
};


export const roleHierarchy = [
  'Network Owner',
  'Manager',
  'Tierlist Administrator',
  'Regulator',
  'Moderator',
  'Senior Tester'
];

export default staffMembers;
